<template>
	<div id="crmcustomerChartmain" class="full">

	</div>
</template>
<style>

</style>

<script>
	import * as echarts from 'echarts';
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {

			}
		},
		watch: {

		},
		mounted() {
			var myChart = echarts.init(document.getElementById('crmcustomerChartmain'));
			var option = option = {
				title: {
					text: '用户日增量'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						crossStyle: {
							color: '#999'
						}
					}
				},
				toolbox: {
					feature: {
						dataView: {
							show: true,
							readOnly: false
						},
						magicType: {
							show: true,
							type: ['line', 'bar']
						},
						restore: {
							show: true
						},
						saveAsImage: {
							show: true
						}
					}
				},
				legend: {
					data: ['crmcustomer', 'crmcustomerorder']
				},
				xAxis: [{
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
					axisPointer: {
						type: 'shadow'
					}
				}],
				yAxis: [{
						type: 'value',
						name: '客户数量',
						min: 0,
						max: 250,
						interval: 50,
						axisLabel: {
							formatter: '{value} 个'
						}
					},
					{
						type: 'value',
						name: '订单数量',
						min: 0,
						max: 25,
						interval: 5,
						axisLabel: {
							formatter: '{value} 个'
						}
					}
				],
				series: [{
						name: '客户数量',
						type: 'bar',
						tooltip: {
							valueFormatter: function(value) {
								return value + ' 个';
							}
						},
						data: [
							2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
						]
					},
					{
						name: '订单数量',
						type: 'line',
						yAxisIndex: 1,
						tooltip: {
							valueFormatter: function(value) {
								return value + ' 个';
							}
						},
						data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
					}
				]
			};
			myChart.setOption(option);
		},
		computed: {

		},

		methods: {

		},
		components: {

		}
	}
</script>
